
import {initSlider} from "../helpers/service.slider";
import {addClass, event, removeClass, selectDoc, toggleClass} from "../utils/utils";

let props = {
    nav: selectDoc('#shopify-section-nav')
}


const initializer = () => {
    initSlider('#testimonials-slider', {
        perView: 1,
        type: 'slider',
        gap: 0,
        peek: {
            before: 0,
            after: 50
        }
    });

    toggleClass(props.nav, 'dark-csr');
    event(window, 'scroll', function () {
        let y = window.pageYOffset || document.documentElement.scrollTop;
        if(y > 100) {
            removeClass(props.nav, 'dark-csr')
        } else {
            addClass(props.nav, 'dark-csr')
        }
    })

}

export const Csr = {
    init: () => initializer()
}
